/**
 * Copyright © 2026 Adnuntius AS.
 */
export function compareById(a: any, b: any): boolean {
  if (a == null && b == null) {
    return true;
  }
  return !!(a && b && a.id === b.id);
}
